<template>
  <div class="list-container">
    <div class="top-fix-area" ref="topFixArea">
    <h1 class="page-title">顧客マスタ情報一覧</h1>
      <div class="mb-2">
        <!-- <router-link to="/customer-graph" class="btn btn-primary">顧客グラフ</router-link> 顧客情報作成ページへのリンク -->
        <router-link
          v-if="userRole == 0 || userRole == 999"
          :to="{ path: '/create-customer', query: getSearchQuery() }"
          class="btn btn-sm btn-primary me-2"
        >
          顧客マスタ情報作成
        </router-link> <!-- 顧客マスタ情報作成ページへのリンク -->

        <!-- Button trigger modal -->
        <button v-if="userRole == 999" type="button" class="btn btn-sm btn-primary me-2" data-bs-toggle="modal" data-bs-target="#exampleModal">
          CSVインポート
        </button>
    
        <!-- Button trigger modal -->
        <button type="button" class="btn btn-sm btn-primary me-2" @click="downloadCsv">CSVエクスポート</button>

        <button
          v-if="userRole == 0 || userRole == 999"
          type="button"
          class="btn btn-sm btn-outline-primary me-2"
          data-bs-toggle="modal"
          data-bs-target="#fieldVisibilityModalCustomer"
          @click="openFieldVisibilityModal"
        >
          測定表示項目設定
        </button>

        <button class="btn btn-sm btn-outline-secondary" @click="isSearchExpanded = !isSearchExpanded">
          {{ isSearchExpanded ? '検索条件を非表示' : '検索条件を表示' }}
        </button>
      </div>

      <!-- Modal -->
      <div class="modal fade" id="exampleModal" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1" aria-labelledby="staticBackdropLabel" aria-hidden="true">
        <div class="modal-dialog modal-lg">
          <div class="modal-content">
            <div class="modal-header">
              <h1 class="modal-title fs-5" id="exampleModalLabel">CSVインポート</h1>
              <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" @click="clearErrorMessages"></button>
            </div>
            <div class="modal-body">
              <div v-if="errorMessages" >
                <div class="error-massage-item" v-for="errorMessage in errorMessages" :key="errorMessage.id">
                  <p class="alert alert-danger mt-2">{{ errorMessage.row_num }}行目：{{errorMessage.messages[0]}}</p>
                </div>
              </div>

              <div class="my-3">
                <p>顧客情報CSVファイル選択</p>
                <input type="file" class="form-control" @change="handleFileChange">
              </div>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-secondary" data-bs-dismiss="modal" @click="clearErrorMessages">閉じる</button>
              <button type="button" class="btn btn-primary" @click="submitFile">インポート</button>
            </div>
          </div>
        </div>
      </div>

      <div class="modal fade" id="fieldVisibilityModalCustomer" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1" aria-hidden="true">
        <div class="modal-dialog modal-lg">
          <div class="modal-content">
            <div class="modal-header">
              <h1 class="modal-title fs-5">測定システム表示項目設定（顧客）</h1>
              <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div class="modal-body">
              <table class="table table-bordered align-middle">
                <thead class="table-light">
                  <tr>
                    <th>項目名</th>
                    <th>キー</th>
                    <th class="text-center">表示</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="field in fieldVisibilityFields" :key="field.field_name">
                    <td>{{ field.field_label }}</td>
                    <td class="text-muted">{{ field.field_name }}</td>
                    <td class="text-center">
                      <div class="form-check form-switch d-inline-block">
                        <input
                          class="form-check-input"
                          type="checkbox"
                          :checked="field.readable"
                          :disabled="field.configurable === false || isSavingFieldVisibility"
                          @change="updateFieldReadable(field.field_name, $event.target.checked)"
                        >
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">閉じる</button>
              <button type="button" class="btn btn-primary" :disabled="isSavingFieldVisibility" @click="saveFieldVisibility">保存</button>
            </div>
          </div>
        </div>
      </div>

      <!-- 検索バーの追加 -->
      <SearchPanelWrapper :key="route.fullPath" v-model="isSearchExpanded" :getTableElement="() => tableWrapper?.$el || tableWrapper?.value" >
        <form class="search-container" style="background-color: #f8f9fa;" @submit.prevent="searchCustomers"> <!-- 背景色を薄く設定 -->
          <div class="row g-3 align-items-center">
            <div class="col-auto">
              <label for="searchName" class="col-form-label">顧客名</label>
            </div>
            <div class="col-auto">
              <input type="text" id="searchName" class="form-control" v-model="searchName" placeholder="顧客名で検索">
            </div>

            <DeletedStatusSelect v-model="searchDeletedStatus" id="customerDeletedStatus" />

            <div class="col-auto">
              <button type="submit" class="btn btn-sm btn-primary mx-1">検索</button>
              <button type="button" class="btn btn-sm btn-secondary mx-1" @click="searchResetCustomers">クリア</button>
            </div>
          </div>
        </form>
      </SearchPanelWrapper>
    </div>

    <div class="d-flex justify-content-end" ref="paginationContainer">
      <Pagination
        :currentPage="currentPage"
        :totalPages="totalPages"
        @change-page="handleChangePage"
      />
    </div>

    <div class="table-wrapper" ref="tableWrapper">
      <table class="master-table table table-bordered">
        <thead class="table-dark">
          <tr>
            <th class="text-nowrap">ID</th>
            <th class="text-nowrap">顧客名</th>
            <th class="text-nowrap">所属する本社</th>
            <th class="text-nowrap">郵便番号</th>
            <th class="text-nowrap">住所</th>
            <th class="text-nowrap">電話番号</th>
            <th class="text-nowrap">FAX</th>
            <th class="text-nowrap">入金予定</th>
            <th class="text-nowrap">請求締切</th>
            <th class="text-nowrap">測定表示</th>
            <th class="btn-cell"></th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="customer in customers" :key="customer.id" :class="{ 'no-active-customer': customer.del_flg == 1 }">
            <td>{{ customer.id }}</td>
            <td class="multiline-text">{{ customer.customer_nm }}</td>
            <td class="multiline-text">
              <span v-if="customer.parent_customer_id">
                {{ customer.parent_customer_nm }}（ID: {{ customer.parent_customer_id }}）
              </span>
              <span v-else class="text-muted">―</span>
            </td>
            <td class="text-nowrap">{{ customer.postal_code }}</td>
            <td>{{customer.prefecture}}{{customer.city}}{{customer.other_address}}</td>
            <td class="text-nowrap">{{ customer.tel_num }}</td>
            <td class="text-nowrap">{{ customer.fax }}</td>
            <td class="text-nowrap">
              {{
                {
                  0: "翌月15日",
                  1: "翌月25日",
                  2: "翌月末",
                  3: "翌々月5日",
                  4: "翌々月10日"
                }[customer.billing_timing_type]
              }}
            </td>
            <td class="text-nowrap">
              {{
                {
                  0: "5日",
                  1: "10日",
                  2: "15日",
                  3: "20日",
                  4: "25日",
                  5: "月末"
                }[customer.billing_deadline]
              }}
            </td>
            <td class="text-nowrap">
              <div v-if="userRole == 0 || userRole == 999" class="form-check form-switch d-inline-block">
                <input
                  class="form-check-input"
                  type="checkbox"
                  :checked="isVisibleInMeasure(customer.id)"
                  @change="toggleMeasureVisibility(customer.id, $event.target.checked)"
                >
              </div>
              <span v-else>{{ isVisibleInMeasure(customer.id) ? '表示' : '非表示' }}</span>
            </td>
            <td  class="btn-cell text-nowrap">
              <router-link :to="{ name: 'CustomerDetail', params: { id: customer.id }, query: getSearchQuery() }"> <!-- 顧客情報詳細ページへのリンク -->
                <button type="button" class="btn btn-sm btn-info">詳細</button>
              </router-link>

              <router-link v-if="userRole == 0 || userRole == 999" :to="{ name: 'CustomerEdit', params: { id: customer.id }, query: getSearchQuery() }"> <!-- 顧客情報編集ページへのリンク -->
                <button type="button" class="btn btn-sm btn-success mx-2">編集</button>
              </router-link>

              <button v-if="customer.del_flg == 0 && (userRole == 0 || userRole == 999)" class="btn btn-sm btn-danger" data-bs-toggle="modal" data-bs-target="#deleteModal" @click="handleDeleteClick(customer.id)">削除</button>
              <button v-if="customer.del_flg == 1 && (userRole == 0 || userRole == 999)" class="btn btn-sm btn-warning" data-bs-toggle="modal" data-bs-target="#restoreModal" @click="handleRestoreClick(customer.id)">復元</button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <!-- 削除確認モーダル -->
    <DeleteConfirmationModal
      :paramsId="paramsIdToDelete"
      @confirmDelete="handleConfirmDelete"
    />

    <!-- 復元確認モーダル -->
    <RestoreConfirmationModal
      :paramsId="paramsIdToRestore"
      @confirmRestore="handleConfirmRestore"
    />
  </div>
</template>

<script>
import { ref, computed, onMounted, watchEffect } from 'vue';
import { useStore } from 'vuex';
import { useRouter } from 'vue-router';
import { useRoute } from 'vue-router';
import {
  getCustomers,
  deleteCustomer,
  restoreCustomer,
  exportCustomersCsv,
  importCustomersCsv,
  getMasterFieldVisibilities,
  updateMasterFieldVisibilities,
  getMasterRecordVisibilities,
  updateMasterRecordVisibility
} from '@/api/axios';
import { Modal } from 'bootstrap';
import SearchPanelWrapper from '@/components/searchPanels/SearchPanelWrapper.vue';
import DeleteConfirmationModal from '@/components/shared/DeleteConfirmationModal.vue';
import RestoreConfirmationModal from '@/components/shared/RestoreConfirmationModal.vue';
import Pagination from '@/components/shared/Pagination.vue';
import DeletedStatusSelect from '@/components/shared/DeletedStatusSelect.vue';

export default {
  components: {
    SearchPanelWrapper,
    DeleteConfirmationModal,
    RestoreConfirmationModal,
    Pagination,
    DeletedStatusSelect
  },
  setup() {
    const TARGET_CLIENT_SYSTEM = 'measure';
    const title = ref('顧客情報一覧');

    watchEffect(() => {
      document.title = title.value;
    });

    const store = useStore();
    const router = useRouter();
    const route = useRoute();
    const userRole = computed(() => store.state.userRole);
    const customers = ref([]);
    const selectedFile = ref(null);
    const recordVisibilityMap = ref({});
    const fieldVisibilityFields = ref([]);
    const isSavingFieldVisibility = ref(false);

     // エラーメッセージ用のリアクティブプロパティ
    const errorMessages = ref({});

    // 検索用のデータプロパティ
    const searchName = ref('');
    const searchDeletedStatus = ref('active');

    // 削除モーダルへ渡すID
    const paramsIdToDelete = ref(null);
    const paramsIdToRestore = ref(null);

    // テーブルの高さの動的な設定
    const topFixArea = ref(null);
    const tableWrapper = ref(null);
    const paginationContainer = ref(null);

    // 検索パネルの展開状態を管理するためのリアクティブプロパティ
    const isSearchExpanded = ref(true);

    // ▼▼ 共通：検索条件をそのまま query として返す ▼▼
    const getSearchQuery = () => ({
      customer_name: searchName.value,
      customer_deleted_status: searchDeletedStatus.value,
      customer_page: currentPage.value || 1
    });

    // ページネーション
    const currentPage = ref(1);
    const totalPages = ref(20); // トータルページ数を管理するためのプロパティ

    const isVisibleInMeasure = (recordId) => recordVisibilityMap.value[recordId] !== false;

    const fetchRecordVisibilities = async () => {
      const recordIds = customers.value.map(customer => customer.id);
      if (recordIds.length === 0) {
        recordVisibilityMap.value = {};
        return;
      }

      try {
        const response = await getMasterRecordVisibilities('customer', TARGET_CLIENT_SYSTEM, recordIds);
        const visibilities = response.data?.visibilities || {};
        recordVisibilityMap.value = Object.fromEntries(
          recordIds.map(id => [id, visibilities[String(id)] !== false])
        );
      } catch (error) {
        console.error('顧客表示可否データの取得に失敗しました:', error);
      }
    };

    const toggleMeasureVisibility = async (recordId, visible) => {
      const previous = isVisibleInMeasure(recordId);
      recordVisibilityMap.value = { ...recordVisibilityMap.value, [recordId]: visible };

      try {
        await updateMasterRecordVisibility('customer', TARGET_CLIENT_SYSTEM, recordId, visible);
      } catch (error) {
        recordVisibilityMap.value = { ...recordVisibilityMap.value, [recordId]: previous };
        store.dispatch('setFlashMessage', { message: '測定表示設定の更新に失敗しました', type: 'danger' });
      }
    };

    const openFieldVisibilityModal = async () => {
      try {
        const response = await getMasterFieldVisibilities('customer', TARGET_CLIENT_SYSTEM);
        fieldVisibilityFields.value = response.data?.fields || [];
      } catch (error) {
        console.error('表示項目設定の取得に失敗しました:', error);
      }
    };

    const updateFieldReadable = (fieldName, readable) => {
      fieldVisibilityFields.value = fieldVisibilityFields.value.map(field => (
        field.field_name === fieldName ? { ...field, readable } : field
      ));
    };

    const closeFieldVisibilityModal = () => {
      const modalElement = document.getElementById('fieldVisibilityModalCustomer');
      const modal = Modal.getInstance(modalElement) || new Modal(modalElement);
      modal.hide();
    };

    const saveFieldVisibility = async () => {
      isSavingFieldVisibility.value = true;
      try {
        const fields = fieldVisibilityFields.value
          .filter(field => field.configurable !== false)
          .map(field => ({
            field_name: field.field_name,
            readable: field.readable
          }));

        await updateMasterFieldVisibilities('customer', TARGET_CLIENT_SYSTEM, fields);
        await fetchCustomers(currentPage.value);
        store.dispatch('setFlashMessage', { message: '測定システム表示項目を更新しました', type: 'success' });
        closeFieldVisibilityModal();
      } catch (error) {
        store.dispatch('setFlashMessage', { message: '表示項目設定の更新に失敗しました', type: 'danger' });
      } finally {
        isSavingFieldVisibility.value = false;
      }
    };

    const fetchCustomers = async (page = 1) => {
      try {
        const response = await getCustomers({
          name: searchName.value,
          deleted_status: searchDeletedStatus.value,
          page: page
        });
        customers.value = response.data.customers;
        totalPages.value = response.data.meta.total_pages;
        currentPage.value = response.data.meta.current_page;
        await fetchRecordVisibilities();
      } catch (error) {
        console.error('顧客情報ーデータの取得に失敗しました:', error);
      }
    };

    const handleChangePage = (page) => {
      if (page >= 1 && page <= totalPages.value) {
        fetchCustomers(page);

        const q = getSearchQuery();
        q.customer_page = page;

        router.replace({
          path: '/customers',
          query: q
        });

        // スクロールを tableWrapper のトップへ
        if (tableWrapper.value) {
          tableWrapper.value.scrollTop = 0;
        }
      }
    };

    const handleDeleteClick = (customerId) => {
      paramsIdToDelete.value = customerId;
    };

    const handleRestoreClick = (customerId) => {
      paramsIdToRestore.value = customerId;
    };

    const customerErrorMessage = (error, fallbackMessage) => {
      const responseData = error?.response?.data;
      if (typeof responseData === 'string' && responseData) return responseData;
      if (!responseData || typeof responseData !== 'object') return fallbackMessage;

      const [fieldName, messages] = Object.entries(responseData)[0] || [];
      const message = Array.isArray(messages) ? messages[0] : messages;
      if (!message) return fallbackMessage;
      if (fieldName === 'base') return message;

      const fieldLabel = {
        parent_customer_id: '親顧客',
        del_flg: '削除状態'
      }[fieldName] || '';
      return `${fieldLabel}${message}`;
    };
    
    const handleConfirmDelete = async (customerId) => {
      try {
        await deleteCustomer(customerId);
        store.dispatch('setFlashMessage', { message: '顧客情報が削除されました', type: 'success' });
        await fetchCustomers(currentPage.value);
      } catch (error) {
        store.dispatch('setFlashMessage', {
          message: customerErrorMessage(error, '顧客情報削除に失敗しました'),
          type: 'danger'
        });
      }
    };

    const handleConfirmRestore = async (customerId) => {
      try {
        await restoreCustomer(customerId);
        store.dispatch('setFlashMessage', { message: '顧客情報が復元されました', type: 'success' });
        await fetchCustomers(currentPage.value);
      } catch (error) {
        store.dispatch('setFlashMessage', {
          message: customerErrorMessage(error, '顧客情報復元に失敗しました'),
          type: 'danger'
        });
      }
    };

    // CSVエクスポート
    const downloadCsv = async () => {
      try {
        const response = await exportCustomersCsv({
          name: searchName.value,
          deleted_status: searchDeletedStatus.value
        });

        // 現在の年月日時分秒を取得してフォーマット
        const now = new Date();
        const timestamp = `${now.getFullYear()}${(now.getMonth() + 1).toString().padStart(2, "0")}${now.getDate().toString().padStart(2, "0")}_${now.getHours().toString().padStart(2, "0")}${now.getMinutes().toString().padStart(2, "0")}${now.getSeconds().toString().padStart(2, "0")}`;

        const fileName = `m_customers_${timestamp}.csv`; // 動的なファイル名

        // CSVファイルをダウンロード
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", fileName);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      } catch (error) {
        console.error("CSVダウンロードエラー", error);
      }
    };

    // CSVインポート
    const handleFileChange = (event) => {
      selectedFile.value = event.target.files[0]; // 選択されたファイルを保存
    };

    // モーダルを閉じる処理
    const closeModal = () => {
      const modalElement = document.getElementById('exampleModal');
      const modal = Modal.getInstance(modalElement) || new Modal(modalElement);
      modal.hide();
    };

    // モーダルが閉じた後に実行される処理
    const onModalHidden = () => {
      clearErrorMessages(); // エラーメッセージをクリアする関数を呼び出す
    };

    // モーダルの閉じるボタンのアクション
    const clearErrorMessages = () => {
      errorMessages.value = {}; // エラーメッセージをクリア
      selectedFile.value = null; // ファイルをクリア

      // inputタグのvalueをリセット
      const input = document.querySelector('.form-control[type="file"]');
      if (input) {
        input.value = '';
      }
    };

    const submitFile = async () => {
      if (!selectedFile.value) {
        store.dispatch('setFlashMessage', { message: 'ファイルが選択されていません', type: 'danger' });
        return;
      }

      try {
        await importCustomersCsv(selectedFile.value); // 選択されたファイルを関数に渡す
        store.dispatch('setFlashMessage', { message: 'アップロードに成功しました', type: 'success' });
        // モーダルを閉じる
        closeModal();

        // モーダルが完全に閉じた後に実行されるイベントリスナーを追加
        document.getElementById('exampleModal').addEventListener('hidden.bs.modal', onModalHidden);

        // 顧客情報の再取得
        await fetchCustomers();
      } catch (error) {
        if (error.response && error.response.data) {
          // エラーメッセージをerrorMessagesにセット
          errorMessages.value = error.response.data || {};
        }
        console.error('アップロードに失敗しました', error);
        store.dispatch('setFlashMessage', { message: 'アップロードに失敗しました', type: 'danger' });
      }
    };

    // 顧客を検索するメソッド
    const searchCustomers = async () => {
      await fetchCustomers(1);

      const q = getSearchQuery();
      q.customer_page = 1;

      router.push({
        path: '/customers',
        query: q
      });
    };

    // 顧客を検索リセットするメソッド
    const searchResetCustomers = async () => {
      searchName.value = ''; // 名前検索条件をクリア
      searchDeletedStatus.value = 'active';
      await fetchCustomers(1);

      const q = getSearchQuery();
      q.customer_page = 1;

      router.replace({
        path: '/customers',
        query: q
      });
    };

    // ▼▼▼ クエリパラメータから検索条件を復元 ▼▼▼
    onMounted(() => {
      const q = route.query;

      searchName.value = q.customer_name || '';
      searchDeletedStatus.value = q.customer_deleted_status || 'active';
      currentPage.value = q.customer_page ? Number(q.customer_page) : 1;

      fetchCustomers(currentPage.value);
    });

    return {
      title,
      route,
      userRole,
      customers,
      paramsIdToDelete,
      paramsIdToRestore,
      handleDeleteClick,
      handleConfirmDelete,
      handleRestoreClick,
      handleConfirmRestore,
      downloadCsv,
      selectedFile,
      handleFileChange,
      submitFile,
      errorMessages,
      clearErrorMessages,
      searchName,
      searchDeletedStatus,
      getSearchQuery,
      currentPage,
      totalPages,
      handleChangePage,
      searchCustomers,
      searchResetCustomers,
      isVisibleInMeasure,
      toggleMeasureVisibility,
      openFieldVisibilityModal,
      updateFieldReadable,
      saveFieldVisibility,
      fieldVisibilityFields,
      isSavingFieldVisibility,
      isSearchExpanded,
      topFixArea,
      tableWrapper,
      paginationContainer
    };
  }
};
</script>

<style scoped>
.no-active-customer td {
  background-color: #aaa;
}
</style>
